import React from 'react';
import img1 from '../img/1.jpeg';
import img2 from '../img/2.jpeg';
import img3 from '../img/3.jpeg';
import { Card, Col, Image, Row, Typography } from 'antd';
import { motion } from "framer-motion";
const { Paragraph, Text, Title } = Typography;

const About = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.3 }}
    >
      <div className='site-page'>
        <Card className='content-page-card' bordered={false}>
          <Row gutter={[20, 20]} align='top'>
            <Col xs={24} lg={12}>
              <Title level={3} style={{ marginTop: 0 }}>Керуюча компанія</Title>
              <Paragraph copyable>ТОВ КЕРУЮЧА КОМПАНІЯ ГЕТЬМАН-1</Paragraph>
              <Paragraph>Код за ЄДРПОУ: <Text copyable>44017359</Text></Paragraph>
              <Paragraph>IBAN: <Text copyable>UA753052990000026001030110821</Text></Paragraph>
              <Paragraph>Банк: <Text copyable>АТ КБ "ПРИВАТБАНК"</Text></Paragraph>
              <Paragraph>Контактний телефон: <Text copyable><a href='tel: +380500401898'>+38 (050)-040-18-98</a></Text></Paragraph>
            </Col>
            <Col xs={24} lg={12}>
              <Image.PreviewGroup
                items={[
                  img1,
                  img2,
                  img3,
                ]}
              >
                <Image
                  className='content-page-image'
                  width={'100%'}
                  src={img1}
                  alt='Прибудинкова територія'
                />
              </Image.PreviewGroup>
            </Col>
          </Row>
        </Card>
      </div>
    </motion.div>
  );
};
export default About;
